






































import Vue from 'vue'
import { TOP_PAGE_FAQ } from '@/top/config/const'

export default Vue.extend({
  name: 'TopPageFaq',
  computed: {
    faqItems(): { [key: string]: string }[] {
      return TOP_PAGE_FAQ
    }
  }
})
